import React from 'react';
import styles from './ModeSelector.module.css';
import type { Mode, LocalizedString } from '../../types';
import { useLocale } from '../../contexts/LocaleContext';
import { getLocalizedString } from '../../utils/localization';
import clsx from 'clsx';
import { t } from '../../locales/translations';

interface ModeSelectorProps {
    modes: Mode[];
    selectedMode: string;
    onSelectMode: (modeId: string) => void;
    label?: LocalizedString;
}

export const ModeSelector: React.FC<ModeSelectorProps> = ({
    modes,
    selectedMode,
    onSelectMode,
    label
}) => {
    const { selectedLocale } = useLocale();

    if (!modes || modes.length === 0) return null;

    const displayLabel = label
        ? getLocalizedString(label, selectedLocale)
        : t('mode', selectedLocale);

    return (
        <div className={styles.modeSelector}>
            <span className={styles.label}>{displayLabel}:</span>
            <div className={styles.options}>
                {modes.map((mode) => (
                    <button
                        key={mode.id}
                        className={clsx(
                            styles.option,
                            selectedMode === mode.id && styles.selected
                        )}
                        onClick={() => onSelectMode(mode.id)}
                        title={getLocalizedString(mode.title, selectedLocale)}
                    >
                        {getLocalizedString(mode.title, selectedLocale)}
                    </button>
                ))}
            </div>
        </div>
    );
};
